import React, { Component } from 'react'
import { Tag, Icon } from 'antd'

import Keyword from './Keyword'
class SynonymItem extends Component<any, any> {
    render() {
        const { name, summary, weight } = this.props
        return (
            <div style={{ paddingBottom: '0.5rem', width: '100%', fontSize: '1rem' }}>
                <div style={{ marginBottom: '0.5rem' }}>
                    <strong>{name ? name : 'קבוצה ללא שם'}</strong>
                    <span style={{ fontSize: '0.8rem', padding: '0 0.5rem' }}>(משקל - {weight})</span>
                </div>
                <div>
                    {!!summary && summary.split(' ').map((keyword, index) => <Keyword keyword={keyword} key={index} />)}
                </div>
            </div>
        )
    }
}

export default SynonymItem
